// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6776) return "static/chunks/6776.709a3374137fc0d9.js";
	if (chunkId === 2908) return "static/chunks/2908.ae643090be3069c7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"6689":"252dbadc02ba6f55","7771":"f7211254813dd67a","9675":"631f45ebe4498d3b","9914":"0b8e3c3707672ecc"}[chunkId] + ".js";
};